<template>
  <div class="p-book-interview">
    <ucar-title>{{title}}</ucar-title>
    <div class="header">
      <h2>{{pageTitle}}</h2>
    </div>
    <div class="pane">
      <dl class="address">
        <dt>面试地点</dt>
        <dd>{{apiData.interviewAddress}}</dd>
      </dl>
      <div class="time">
        <span class="title">预约日期</span>
        <div>
          <div class="content">
            <ucar-radio
              class="date-item"
              v-for="(date, index) in apiData.appointDateDetails"
              :key="date.appointDate"
              :check="index === currentDate"
              :disable="date.getiSAppointFull || date.isExpired"
              @select="selectDate(index)"
            >
              {{date.appointDate}}
              <span v-if="date.getiSAppointFull">(已满)</span>
            </ucar-radio>
          </div>
          <span class="title">时间</span>
          <div
            class="content"
          >
            <ucar-radio
              v-for="time in options.appointTimeDetails"
              :key="time.appointTime"
              :check="currentTimeId === time.timeId"
              :disable="time.isAppointFull || time.isExpired"
              @select="selectTime(time)"
            >
              {{time.appointTime}}
              <span v-if="time.isAppointFull">(已满)</span>
            </ucar-radio>
          </div>
        </div>
      </div>
    </div>
    <div class="button-box">
      <ucar-button size="full" @click="submit">提交</ucar-button>
    </div>
  </div>
</template>

<script>
import { getAppointmentTime, bookingInterviewTime } from '../../api'

export default {
  name: 'book-interview',
  data () {
    return {
      edit: this.$route.query.edit || false,
      apiData: {
        interviewAddress: '',
        appointDateDetails: []
      },
      currentDate: 0,
      currentTimeId: 0
    }
  },
  computed: {
    options () {
      return this.apiData.appointDateDetails[this.currentDate] || {
        appointTimeDetails: []
      }
    },
    pageTitle () {
      return this.edit ? '待面试' : '待预约面试'
    }
  },
  methods: {
    selectDate (index) {
      this.currentDate = index
      if (this.options.appointTimeDetails.map(item => item.timeId).indexOf(this.currentTimeId) === -1) {
        this.currentTimeId = this.options.appointTimeDetails.find(item => !item.isAppointFull).timeId
      }
    },
    selectTime (item) {
      this.currentTimeId = item.timeId
    },
    submit () {
      this.apiUpdateInterviewTime(this.currentTimeId, _ => {
        this.$alert({
          content: `预约成功`,
          type: 'confirm',
          callback: () => {
            this.$router.push({
              name: 'enroll-result',
              query: { id: this.$route.query.id }
            })
          }
        })
      })
    },
    apiGetInterviewTime () {
      // 获取面试时间列表
      getAppointmentTime(this.$route.query.id, this.vuexRegType).then(data => {
        data.appointDateDetails.sort((a, b) => {
          return parseInt(a.appointDate.replace(/[^\d]/g, '')) - parseInt(b.appointDate.replace(/[^\d]/g, ''))
        })
        this.apiData = data
        this.selectDate(0)
      })
    },
    apiUpdateInterviewTime (appointTimeId, callback) {
      // 提交面试时间
      bookingInterviewTime(this.$route.query.id, this.vuexRegType, appointTimeId).then(() => {
        this.changeStatusToReviewInfo()
        callback && callback()
      })
    }
  },
  mounted () {
    this.apiGetInterviewTime()
  }
}
</script>

<style lang="stylus" scoped>
@import "../../styles/variable.styl";
.p-book-interview {
  display: flex;
  flex-flow: column nowrap;
  .header {
    background-color: $ucar_dark_bg;
    padding: 60px 0 90px;
    h2 {
      color: $ucar_main_color;
      text-align: center;
    }
  }
  .pane {
    flex: 1 0 auto;
    margin: $ucar_side_gutter $ucar_side_gutter 0;
    padding: $ucar_side_gutter;
    border: 1px solid $ucar_light_border;
    background-color: #fff;
    .address {
      color: $ucar_font_color;
      display: flex;
      flex-wrap: nowrap;
      margin-bottom: 60px;
      dt {
        flex-shrink: 0;
        padding-right: 30px;
      }
      dd {
        flex-shrink: 1;
      }
    }
    .time {
      .title {
        display: block;
        color: $ucar_font_color;
        margin-bottom: 40px;
      }
      .content {
        margin-bottom: 60px;
        overflow: hidden;
        .date-item {
          width: 50%;
          float: left;
          box-sizing: border-box;
        }
      }
    }
  }
  .button-box {
    padding: $ucar_side_gutter;
  }
}
</style>
